<template>
  <div class="container">
    <!--<p>Geladen? {{ loaded }}</p>-->
    <nav class="breadcrumbs">
      <SfBreadcrumbs :breadcrumbs="breadcrumbs" />
    </nav>

    <header class="blogHeader">
      <div class="row">
        <header class="col-12">
          <h1>PapierFischer Blog</h1>
        </header>
        <div class="col-12 mb-3 mt-1">
          <SearchBar />
        </div>

        <CategoryFilter
          :blogCategories="blogCategories"
          class="col-12 col-lg-9 col-md-8 d-flex align-items-center mobile-scroll mb-3"
        />

        <div class="col-12 col-lg-3 col-md-4 mb-1">
          <div class="blogHeader--controls d-flex justify-content-end" :class="{ loading: !loaded }">
            <button
              class="btn btn-secondary d-flex align-items-center"
              :class="`order-${order}`"
              type="button"
              @click="setOrder"
            >
              {{ $t('blog-sortby.' + order) }}
            </button>
            <span> {{ totalPosts }} Artikel </span>
          </div>
        </div>
      </div>
    </header>

    <PostsList :posts="loadedPosts" :class="{ loading: !loaded }" />

    <div class="readmore d-flex justify-content-center" v-if="loadedPosts.length < totalPosts">
      <button type="button" class="btn btn-secondary" :disabled="!loaded" @click="loadmorePosts">
        <span v-show="loaded">Mehr laden</span>
        <span v-show="!loaded" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true">
          Weitere Artikel werden geladen ...
        </span>
      </button>
    </div>

    <!--<p>Ich sehe aktuell: {{ loadedPosts.length }} Artikel</p>-->
  </div>
</template>

<script>
import { useBlogStore } from '~/stores/blog';
import PostsList from '~/components/Blog/PostsList';
import CategoryFilter from '~/components/Blog/CategoryFilter';
import { useContext, computed, ref } from '@nuxtjs/composition-api';
import { getBreadcrumbs } from '~/modules/catalog/product/getters/productGetters';
import { SfBreadcrumbs } from '@storefront-ui/vue';
import SearchBar from '~/components/Blog/BlogSearchBar';

export default {
  name: 'blog-page',
  layout: 'blog',
  components: {
    PostsList,
    CategoryFilter,
    SfBreadcrumbs,
    SearchBar,
  },
  data() {
    return {};
  },
  async asyncData({ route, $axios }) {
    const c = route.query.c;
    const blogStore = useBlogStore();
    const order = computed(() => blogStore.order);
    const storeCategories = computed(() => blogStore.categories);
    const posts = ref([]);

    blogStore.setCurrentCategory(c);

    const blogCategories = await $axios.get('/blog-api/' + 'categories/');
    blogStore.setCategories(blogCategories.data);

    // await blogStore.reloadPosts(10, order.value)

    const currentCategory = computed(() => blogStore.currentCategory);

    let catQuery = '';
    if (c) {
      catQuery = '&categories=' + currentCategory.value?.id;
    }
    try {
      const response = await $axios.get('/blog-api/' + 'posts/' + '?per_page=10&order=' + order.value + catQuery);
      if (response) {
        await blogStore.setTotalPosts(response?.headers['x-wp-total']);
        posts.value = response?.data;
      }
    } catch (error) {
    } finally {
    }

    blogStore.setPosts(posts.value);

    return {
      posts: posts.value,
      blogCategories: storeCategories.value,
      currentCategory: currentCategory.value,
    };
  },
  setup() {
    const postsToReload = ref(9);
    const blogStore = useBlogStore();
    const order = computed(() => blogStore.order);
    const loaded = computed(() => blogStore.loaded);
    const loadedPosts = computed(() => blogStore.posts);
    const totalPosts = computed(() => blogStore.totalPosts);

    const { localePath } = useContext();

    const setOrder = async () => {
      blogStore.setLoaded(false);
      blogStore.setOrder(order.value);
    };

    const loadmorePosts = async () => {
      blogStore.setLoaded(false);
      blogStore.loadmorePosts(postsToReload.value, order.value);
    };

    const breadcrumbs = ref([
      {
        text: 'Home',
        link: localePath('/'),
      },
      {
        text: 'Blog',
        link: localePath('/blog/'),
      },
    ]);

    return {
      loadedPosts,
      loadmorePosts,
      postsToReload,
      loaded,
      order,
      setOrder,
      breadcrumbs,
      totalPosts: totalPosts.value,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/blog/blogStyles.scss';
.container {
  overflow: hidden;
}
.breadcrumbs {
  @media (max-width: $lg) {
    display: none;
  }
}
@media (max-width: $lg) {
  .mobile-scroll::-webkit-scrollbar {
    display: none;
  }
  .mobile-scroll {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}
</style>
